import React, { useEffect, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaTwitter,
  FaMapMarkerAlt,
  FaPhone,
  FaMailBulk,
  FaClock,
  FaArrowUp,
} from "react-icons/fa";
import { motion } from "framer-motion";

const generateGoogleMapsURL = (lat, lng) =>
  `https://www.google.com/maps?q=${lat},${lng}`;

const locations = {
  Hospet: { lat: 15.475320, lng: 76.576961 },
  Gangavathi: { lat: 15.475320, lng: 76.576961 },
  Kurekuppa: { lat: 15.216180927792266, lng: 76.6389336251353 },
  Danapur: { lat: 15.17613699827162, lng: 76.36782308734786 },
  Raichur: { lat: 16.199794845108936, lng: 77.25309554837399 },
  Ballari: { lat: 15.139708435244031, lng: 76.93125488449941 },
};

const branches = [
  "Hospet",
  "Gangavathi",
  "Kurekuppa",
  "Danapur",
  "Raichur",
  "Ballari",
];

// const API_BASE_URL = 'https://japl-backend.onrender.com/api';
const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api');

const Footer = () => {
  const [qrCodes, setQrCodes] = useState({});

  useEffect(() => {
    async function fetchQRCodes() {
      const fetched = {};
      for (const branch of branches) {
        try {
          const res = await fetch(`${API_BASE_URL}/branchqrcode/${encodeURIComponent(branch)}`);
          if (res.ok) {
            const data = await res.json();
            fetched[branch] = data.qrCodeImageURL;
          }
        } catch (e) {
          // silently ignore errors, fallback to generated QR code
        }
      }
      setQrCodes(fetched);
    }
    fetchQRCodes();
  }, []);

  const generateQRCodeURL = (lat, lng) =>
    `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
      generateGoogleMapsURL(lat, lng)
    )}&size=200x200`;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const footerSections = [
    {
      title: "Our Branches",
      items: ["Hospet", "Gangavathi", "Danapur", "Kurekuppa", "Raichur", "Bellary"],
    },
    {
      title: "Products",
      items: [
        "Heavy CVs",
        "Construction Vehicles",
        "Intermediate CVs",
        "Light CVs",
        "Medium CVs",
        "Buses",
      ],
    },
    {
      title: "Quick Links",
      items: ["Home", "Products", "Enquiry", "Services", "About Us"],
    },
  ];

  return (
    <footer
      className="bg-gradient-to-br from-gray-900 to-blue-950 text-white px-6 pt-12 pb-4 relative z-10 overflow-hidden"
      id="contact"
    >
      <div className="max-w-7xl mx-auto space-y-12 pt-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-4"
          >
            <h2 className="text-2xl font-bold tracking-wide">
              JANATHA AUTOMOBILES PVT LTD
            </h2>
            <p className="text-sm text-gray-300">
              Leading distributor of TATA Motors commercial vehicles with branches
              across North Karnataka.
            </p>

            <div className="flex gap-3 mt-4">
              {[
                { icon: <FaFacebook />, color: "bg-blue-600" },
                { icon: <FaWhatsapp />, color: "bg-green-500" },
                { icon: <FaTwitter />, color: "bg-blue-400" },
                { icon: <FaInstagram />, color: "bg-gradient-to-tr from-yellow-400 to-pink-600" },
              ].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  className={`p-2 rounded-full ${social.color} text-white hover:scale-110 transition`}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </motion.div>

          {/* Navigation Sections */}
          {footerSections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="space-y-4"
            >
              <h3 className="text-xl font-semibold border-b-2 border-blue-500 pb-1 w-fit">
                {section.title}
              </h3>
              <ul className="space-y-2 text-sm text-gray-300">
                {section.items.map((item, idx) => (
                  <li
                    key={idx}
                    className="hover:text-blue-400 cursor-pointer transition"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <div className="bg-white/5 px-8 py-4 rounded-lg space-y-4">
          <div className="flex justify-evenly items-center space-y-3">
            <div className="flex items-center space-x-3">
              <FaPhone className="text-blue-400" />
              <p className="text-sm md:text-lg text-gray-300">Sales: +91 6364861939</p>
            </div>
            <div className="flex items-center space-x-3">
              <FaPhone className="text-blue-400" />
              <p className="text-sm md:text-lg text-gray-300">Service : +91 6364861935</p>
            </div>
          </div>

          <div className="flex justify-evenly items-center space-y-3">
            <div className="flex items-center space-x-3">
              <FaMailBulk className="text-blue-400" />
              <p className="text-sm md:text-lg text-gray-300">Sales : Cre@japl.co.in</p>
            </div>
            <div className="flex items-center space-x-3">
              <FaMailBulk className="text-blue-400" />
              <p className="text-sm md:text-lg text-gray-300">Service : Csc@japl.co.in</p>
            </div>
          </div>
        </div>

        {/* Contact Section (Branches info with QR) */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {branches.map((branch, i) => (
            <div key={i} className="space-y-3 bg-white/5 p-4 rounded-lg">
              <h4 className="text-lg font-medium border-b border-blue-500 pb-1">
                Contact Info - {branch}
              </h4>
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-blue-400 mt-1 w-5 h-5" />
                <p className="text-sm text-gray-300">
                  {branch === "Hospet" && "Janatha Auto Works, #10, Janatha Complex, Hampi Road, Near Bala Talkies, Hospet-583201"}
                  {branch === "Gangavathi" && "Gangavathi Sindhanur Main Road, Marali, Koppal, Karnataka - 583268"}
                  {branch === "Kurekuppa" && "Kurekuppa, Ballari, Karnataka - 583123"}
                  {branch === "Danapur" && "Bangalore Road, Opp BMM Ispat Ltd Plant, Danapuram, Vijayanagara"}
                  {branch === "Raichur" && "Hansihalhudea Village, Near Power Gate, Raichur, Karnataka - 584101"}
                  {branch === "Ballari" && "Near Chaitanya Fuels, Kolagal Village, Ballari, Karnataka - 583101"}
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <FaClock className="text-blue-400" />
                <p className="text-sm text-gray-300">Mon-Sat: 9:00 AM - 7:00 PM</p>
              </div>
              <div className="border border-white/10"></div>

              <div className="flex justify-between items-center gap-4">
                <img
  src={
    qrCodes[branch]
      ? (qrCodes[branch].startsWith('http')
          ? qrCodes[branch]
          : `https://japl-backend-v2jm.onrender.com/${qrCodes[branch].replace(/^\//, '')}`)
      : generateQRCodeURL(locations[branch].lat, locations[branch].lng)
  }
  alt={`QR Code for ${branch} branch`}
  className="w-20 h-20 border-4 border-blue-100  rounded-lg bg-white"
/>

                <p className="text-xs text-gray-500">
                  Scan QR code for directions to {branch} branch
                </p>
              </div>
            </div>
          ))}
        </motion.div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center border-t border-white/10 pt-6 gap-4">
          <p className="text-sm text-gray-400 text-center">
            © {new Date().getFullYear()} JANATHA AUTOMOBILES PVT LTD. All Rights
            Reserved.
          </p>
          <div className="flex space-x-5 text-sm">
            <a
              href="/privacy"
              className="text-gray-400 hover:text-blue-400 transition"
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="text-gray-400 hover:text-blue-400 transition"
            >
              Terms & Conditions
            </a>
             <p className="">
    Developed by{" "}
    <a
      href="https://ravi-web-solutions.netlify.app/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-400 hover:underline font-medium"
    >
      Ravi | <span>Contact: 9380609674</span>
    </a>
     
  </p>
          </div>
          <motion.button
            onClick={scrollToTop}
            whileHover={{ scale: 1.1 }}
            className="p-2.5 bg-blue-600 rounded-full shadow hover:bg-blue-700 transition"
            aria-label="Scroll to top"
          >
            <FaArrowUp className="text-white" />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
